import React from "react";
import JoditEditor from "jodit-react";

export default function DepartmentForm(props) {
    const editorConfig = {
        readonly: false,
        height: 200
    };
    return <>
        <div id={`${
            typeof props.id !== "undefined" ? props.id : "responsive-modal"
        }`} className="modal fade bs-example-modal-lg" tabIndex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true" style={{display: 'none'}}>
            <div className="modal-dialog modal-lg">
                <div className="modal-content">
                    <div className="modal-header">
                        <h4 className="modal-title" id="myLargeModalLabel">{props.title ?? ""}</h4>
                        <button type="button" className={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`}  id={`${
                            typeof props.close !== "undefined" ? props.close : "close"
                        }`} data-dismiss="modal" aria-hidden="true">×</button>
                    </div>
                    <div className="modal-body">
                        <div className="row">
                            <div className="mb-3 form-group col-md-12">
                                <label className="form-label">Department Name</label>
                                <input
                                    name="departmentName"
                                    className="form-control"
                                    id="departmentName"
                                    value={props.formData.departmentName}
                                    onChange={props.onEdit}
                                    placeholder="Department Name"
                                />

                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Department Head</label>
                                <select className="form-control" name="headOfDepartmentID" id="headOfDepartmentID"
                                        value={props.formData.headOfDepartmentID} onChange={props.onEdit}>
                                    <option value="">Select Head of Department</option>
                                    <option value="1">Adam Yau Musa</option>
                                </select>
                            </div>


                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Phone Number</label>
                                <input
                                    type="number"
                                    name="phoneNumber"
                                    className="form-control"
                                    id="phoneNumber"
                                    value={props.formData.phoneNumber}
                                    onChange={props.onEdit}
                                    placeholder="Phone Number"
                                />

                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Email Address</label>
                                <input
                                    name="emailAddress"
                                    className="form-control"
                                    id="emailAddress"
                                    value={props.formData.emailAddress}
                                    onChange={props.onEdit}
                                    placeholder="Email Address"
                                />
                            </div>
                            <div className="mb-3 form-group col-md-6">
                                <label className="form-label">Extension Number</label>
                                <input
                                    name="extensionNo"
                                    className="form-control"
                                    id="extensionNo"
                                    value={props.formData.extensionNo}
                                    onChange={props.onEdit}
                                    placeholder="Extension Number"
                                />
                            </div>
                            <div className="mb-3 col-md-12 form-group">
                                <label className="form-label">Description </label>
                                <JoditEditor
                                    value={props.formData.departmentDescription}
                                    config={editorConfig}
                                    onBlur={props.descriptionHandler}
                                    onChange={(newContent) => {
                                    }}
                                />
                            </div>

                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-default waves-effect" data-dismiss="modal">Close
                        </button>
                        {
                            props.IsFormLoading ?
                                <button type="button" className="btn btn-primary ms-auto">
                                    <span><span className="spinner-border spinner-border-sm me-2" role="status"/> Please wait...</span>
                                </button>
                                :
                                <button type="button" onClick={props.onSubmit}
                                        className="btn btn-danger waves-effect waves-light">{props.btn ?? "submit"}</button>
                        }
                    </div>
                </div>
            </div>
        </div>
    </>
}